import classNames from 'classnames'
import { JSX } from 'react'

import { IForm } from 'core-components/classes/models/IForm'
import { IMultiselectProps, MultiSelect } from 'core-components/library/multiSelect'
import { createComponentFn } from 'onboarding/components/helpers/createComponentFn'
import themesStyles from 'onboarding/components/themes.module.scss'

type TComponentFn<T, R> = (props: IMultiselectProps<T, R>) => JSX.Element

const applyDisabled = <T, R>(component: TComponentFn<T, R>) => {
  return (props: IMultiselectProps<T, R>) => {
    const { disabled, classes } = props
    const disabledTheme = disabled ? themesStyles.disabledDropdown : undefined

    return component({
      ...props,
      classes: {
        ...classes,
        controlClasses: {
          ...classes?.controlClasses,
          root: classNames(classes?.controlClasses?.root, disabledTheme),
        },
      },
    })
  }
}

export const OnboardingMultiselect = <T = IForm, R = string | number>(
  props: IMultiselectProps<T, R>
) =>
  applyDisabled(createComponentFn<IMultiselectProps<T, R> & JSX.IntrinsicAttributes>(MultiSelect))(
    props
  )
